export interface MobileSearchStateInput {
  focused: boolean;
  query: string;
  loading: boolean;
  resultCount: number;
}

export function shouldExpandMobileSearch(input: MobileSearchStateInput): boolean {
  return input.focused || input.query.trim().length > 0 || input.loading || input.resultCount > 0;
}
